(function() {
  'use strict';

  angular.module('wml.portal.app-info', []);

})();
